/**
 * @desc 查询余热发电年计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanYearCogenerationResponse>> {
  return defHttp.post({
    url: '/wap/plan/year/queryPlanCogeneration',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanYearCogenerationResponse>> {
  return defHttp.post({
    url: '/mock/wap/plan/year/queryPlanCogeneration',
    data,
  });
}
